import { Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const defaultCountDown = 5;

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const [countDown, setCountDown] = useState(defaultCountDown);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((c) => c - 1);
    }, 1000);

    const timeoutId = setTimeout(() => {
      navigate("/", { replace: true });
    }, defaultCountDown * 1000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [navigate]);

  return (
    <div className="w:100vw h:100vh  flex jc:center ai:center bg:#dedede">
      <div className="pb:10% flex flex:col ai:center gap:10">
        <h1 className="mb:20">404</h1>
        <p>抱歉，您訪問的頁面不存在</p>
        <p>連結可能已失效，或是該頁面已被移除</p>

        <Button
          danger
          size="large"
          type="primary"
          className="w:120 mt:20"
          icon={<HomeOutlined />}
        >
          <Link to="/">返回首頁</Link>
        </Button>

        <small>您將在 {countDown} 秒後自動返回首頁</small>
      </div>
    </div>
  );
};
